import { Injectable, OnDestroy } from '@angular/core';
import {
    HttpInterceptor,
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpErrorResponse,
} from '@angular/common/http';
import { Observable, Subscription, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { Store } from '@ngrx/store';
import { IAppState } from '../../store/interface/app.state.interface';
import * as UserActions from '../../store/user/user.actions';
import { IUser } from '../../user/interfaces/user.interface';
import { extractErrorMessage } from '../../shared/utils/http-error.util';

@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor, OnDestroy {
    subscriptions: Subscription[] = [];
    loggedInUser: IUser | null = null;
    constructor(
        private messageService: MessageService,
        private store: Store<IAppState>,
        private router: Router,
    ) {
        this.subscriptions.push(
            this.store
                .select((state) => state.user.loggedInUser)
                .subscribe((state) => {
                    this.loggedInUser = state;
                }),
        );
    }

    intercept<T>(req: HttpRequest<T>, next: HttpHandler): Observable<HttpEvent<T>> {
        const apiHost = environment.apiHost || '';
        const basePath = environment.basePath;
        const accessKey = environment.accessKey;
        const hideToastOnError: boolean = req.params.has('hideToastOnError');
        const headers: Record<string, string> = {
            'access-key': accessKey,
            ...(localStorage.getItem('auth_token') && {
                Authorization: localStorage.getItem('auth_token') || '',
            }),
        };

        if (this.loggedInUser?.tenant?.id) {
            headers['tenant-id'] = this.loggedInUser.tenant.id;
        }

        const modifiedReq = req.clone({
            url: apiHost + basePath + req.url,
            setHeaders: headers,
            params: req.params.delete('hideToastOnError'),
        });

        return next.handle(modifiedReq).pipe(
            catchError((error: HttpErrorResponse) => {
                const message = extractErrorMessage(error);

                if (!hideToastOnError) {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: message,
                    });
                }

                if (error.status === 401) {
                    localStorage.removeItem('auth_token');
                    this.store.dispatch(UserActions.setLoggedInUser({ user: null }));
                    this.router.navigate(['/auth/login']);
                }

                return throwError(() => error);
            }),
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach((sub) => sub.unsubscribe());
    }
}
